module.controller('regulationDetailCtrl', [ '$scope', '$rootScope', '$state', 'regulationService', 'alertService', regulationDetailCtrlFn ]);
function regulationDetailCtrlFn($scope, $rootScope, $state, regulationService, alertService) {

	$scope.validation = {
		name : {
			maxlength : 255
		},
		regulationNumber : {
			maxlength : 255
		},
		issuingCompany : {
			maxlength : 255
		},
		sigla : {
			maxlength : 5
		}
	};
	$scope.operationType = $state.current.data.type;
	$scope.idregulation = $state.params.id;
	$scope.regulation = {
		idType : {}
	};
	$scope.loading = false;

	/**
	 * 
	 * @param idUser
	 */
	$scope.load = function(idregulation) {
		$scope.loading = true;

		regulationService.getRegulation(idregulation).then(function(response) {
			$scope.loading = false;

			var responseData = response.getData();
			$scope.regulation = {
				name : responseData.name,
				idType : {
					selected : [ {
						id : responseData.type.id,
						name : responseData.type.name,
						value : responseData.type.value
					} ]
				},
				number : responseData.number,
				issuingCompany : responseData.issuingCompany,
				active : responseData.active,
				totalAnalysis : responseData.totalAnalysis,
				totalTechniques : responseData.totalTechniques,
				sigla: responseData.sigla
			};
		}, function(response) {
			$scope.loading = false;
		});
	};

	/**
	 * 
	 */
	$scope.sendAction = function() {
		if ($scope.operationType == 'create') {
			$scope.create();
		} else {
			$scope.update();
		}
	};

	/**
	 * 
	 */
	$scope.create = function() {
		alertService.showSwtQuestion('Crear normativa', function() {
			$scope.loading = true;

			var createModel = {
				name : $scope.regulation.name,
				idRegulationType : $scope.regulation.idType.selected[0].id,
				number : $scope.regulation.number,
				issuingCompany : $scope.regulation.issuingCompany,
				sigla: $scope.regulation.sigla
			};

			regulationService.createRegulation(createModel).then(function(response) {
				$scope.loading = false;
				alertService.showSuccess('Normativa creada satisfactoriamente');
				$state.go('home.regulationList');
			}, function(response) {
				$scope.loading = false;
			});
		});
	};

	/**
	 * 
	 */
	$scope.update = function() {
		alertService.showSwtQuestion('Actualizar normativa', function() {
			$scope.loading = true;

			var updateModel = {
				name : $scope.regulation.name,
				idRegulationType : $scope.regulation.idType.selected[0].id,
				number : $scope.regulation.number,
				issuingCompany : $scope.regulation.issuingCompany,
				sigla: $scope.regulation.sigla
			};

			regulationService.updateRegulation($scope.idregulation, updateModel).then(function(response) {
				$scope.loading = false;
				alertService.showSuccess('Normativa actualizada satisfactoriamente');
				$state.go('home.regulationList');
			}, function(response) {
				$scope.loading = false;
			});
		});
	};

	$scope.goBack = function() {
		if ($scope.idregulation) {
			var params = {
				id : $scope.idregulation
			};
			$state.go('home.regulationHome', params);
		} else {
			$state.go('home.regulationList');
		}
	};

	if ($scope.operationType == 'update') {
		$scope.load($state.params.id);
	}

}
